"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WHITE = exports.VETERINARIAN_TITLES = exports.TIME_ZONES = exports.STATES_PROVINCES = exports.MONTH_NAMES = exports.LIGHT_GREEN = exports.LIGHTEST_GREY = exports.LIGHTEST_GREEN = exports.LIGHTER_GREY = exports.LAB_TECH_TITLES = exports.GREY = exports.DARK_GREEN = exports.DARKEST_GREY = exports.DARKER_GREEN = exports.COUNTRIES = exports.CONTINENTS = void 0;
// Colors
var WHITE = '#FFFFFF';
exports.WHITE = WHITE;
var GREY = '#58585A';
exports.GREY = GREY;
var LIGHTEST_GREY = '#f9f9f9';
exports.LIGHTEST_GREY = LIGHTEST_GREY;
var LIGHTER_GREY = '#a5a5a7';
exports.LIGHTER_GREY = LIGHTER_GREY;
var DARK_GREEN = '#268D3B';
exports.DARK_GREEN = DARK_GREEN;
var LIGHT_GREEN = '#39B54A';
exports.LIGHT_GREEN = LIGHT_GREEN;
var LIGHTEST_GREEN = '#BCCEBE';
exports.LIGHTEST_GREEN = LIGHTEST_GREEN;
var DARKER_GREEN = '#13441B';
exports.DARKER_GREEN = DARKER_GREEN;
var DARKEST_GREY = '#323233';
exports.DARKEST_GREY = DARKEST_GREY;
var STATES_PROVINCES = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming', 'Auvergne-Rhône-Alpes', 'Bourgogne-Franche-Comté', 'Brittany', 'Centre-Val de Loire', 'Corsica', 'Grand Est', 'Hauts-de-France', 'Île-de-France', 'Normandy', 'Nouvelle-Aquitaine', 'Occitanie', 'Pays de la Loire', 'Provence-Alpes-Côte d\'Azur', 'French Guiana', 'Guadeloupe', 'Martinique', 'Mayotte', 'Réunion'];
exports.STATES_PROVINCES = STATES_PROVINCES;
var COUNTRIES = ['United States', 'France'];
exports.COUNTRIES = COUNTRIES;
var TIME_ZONES = ['America/Adak', 'America/Anchorage', 'America/Chicago', 'America/Denver', 'America/Detroit', 'America/Indiana/Indianapolis', 'America/Indiana/Knox', 'America/Indiana/Marengo', 'America/Kentucky/Louisville', 'America/Los_Angeles', 'America/New_York', 'America/Phoenix', 'Europe/Paris', 'America/Martinique', 'America/Guadeloupe', 'America/Cayenne', 'Indian/Reunion', 'Indian/Mayotte', 'Pacific/Tahiti', 'Pacific/Marquesas', 'Pacific/Gambier', 'America/St_Barthelemy', 'America/Miquelon', 'Indian/Kerguelen', 'Atlantic/St_Helena' // Saint Helena (includes Saint Helena, Ascension and Tristan da Cunha)
];
exports.TIME_ZONES = TIME_ZONES;
var MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
exports.MONTH_NAMES = MONTH_NAMES;
var CONTINENTS = ['AFRICA', 'ANTARCTICA', 'ASIA', 'AUSTRALIA', 'EUROPE', 'NORTH_AMERICA', 'SOUTH_AMERICA']; // Veterinarian Form

exports.CONTINENTS = CONTINENTS;
var VETERINARIAN_TITLES = ['DVM', 'VMD', 'Other', 'None'];
exports.VETERINARIAN_TITLES = VETERINARIAN_TITLES;
var LAB_TECH_TITLES = ['EVT', 'Lab Technician', 'Other', 'None'];
exports.LAB_TECH_TITLES = LAB_TECH_TITLES;